import Phaser from "phaser";
import ArcherCharacter from "../Character";
import SkillManager from "../Skills/SkillManager";
import { ILevelInputController } from "./ILevelInputController";

export default class DesktopLevelInputController implements ILevelInputController {
  private mScene: Phaser.Scene;
  private mOnPointerDown: () => void;
  private mOnPointerUp: () => void;
  private mOnKeyDown: (event: KeyboardEvent) => void;

  constructor(scene: Phaser.Scene, character: ArcherCharacter, skillManager: SkillManager) {
    this.mScene = scene;

    this.mOnPointerDown = () => {
      character.PullArrow();
    };

    this.mOnPointerUp = () => {
      character.ReleaseArrow();
    };

    this.mOnKeyDown = (event: KeyboardEvent) => {
      const activeStates = skillManager.GetActiveSkillStates();
      for (const state of activeStates) {
        const keyCode =
          Phaser.Input.Keyboard.KeyCodes[
            state.skill.KeyBinding as keyof typeof Phaser.Input.Keyboard.KeyCodes
          ];
        if (keyCode && event.keyCode === keyCode) {
          skillManager.TryActivateSkill(
            state.skill.KeyBinding,
            character.GetArrowCaster(),
            character
          );
        }
      }
    };

    scene.input.on("pointerdown", this.mOnPointerDown);
    scene.input.on("pointerup", this.mOnPointerUp);

    if (scene.input.keyboard != null) {
      scene.input.keyboard.on("keydown", this.mOnKeyDown);
    }
  }

  public Destroy(): void {
    this.mScene.input.off("pointerdown", this.mOnPointerDown);
    this.mScene.input.off("pointerup", this.mOnPointerUp);
    if (this.mScene.input.keyboard != null) {
      this.mScene.input.keyboard.off("keydown", this.mOnKeyDown);
    }
  }
}
